/**
 * Tiny pub/sub used to decouple the axios layer from Redux.
 *
 * When a session becomes invalid (refresh fails), the axios interceptor emits
 * a 'session-expired' event. The app (store bootstrap) subscribes and performs
 * the logout/redirect. This avoids importing the store into the axios module
 * (which would create a circular dependency).
 */
const listeners = new Map();

export const AUTH_EVENTS = {
  SESSION_EXPIRED: 'session-expired',
  UNAUTHORIZED: 'unauthorized',
  FORBIDDEN: 'forbidden',
  SERVER_ERROR: 'server-error',
};

export const authEvents = {
  on(event, handler) {
    if (!listeners.has(event)) listeners.set(event, new Set());
    listeners.get(event).add(handler);
    return () => listeners.get(event)?.delete(handler);
  },
  emit(event, payload) {
    listeners.get(event)?.forEach((handler) => {
      try {
        handler(payload);
      } catch {
        /* listener errors must not break the emitter */
      }
    });
  },
};

export default authEvents;
